import { gql } from '@apollo/client';

export const MUTATION_CREATE_ARTICLE = gql`
  mutation createArticle($input: CreateArticleInput!) {
    createArticle(input: $input) {
      article {
        id
        title
      }
    }
  }
`;

export const MUTATION_UPDATE_ARTICLE = gql`
  mutation updateArticle($input: UpdateArticleInput!) {
    updateArticle(input: $input) {
      article {
        id
        title
      }
    }
  }
`;

export const QUERY_ARTICLE_DETAIL = gql`
  query article($id: ID!) {
    article(id: $id) {
      article {
        id
        status
        type
        articleData {
          index
          type
          content
          title
          links {
            hls
            hqMp4
            lqMp4
            thumbnail
          }
        }
      }
    }
  }
`;

export const MUTATION_CREATE_ARTICLE_VIDEO = gql`
  mutation createArticleVideo($input: CreateArticleVideoInput!) {
    createArticleVideo(input: $input) {
      video {
        id
        videoHash
      }
    }
  }
`;
